import React from "react";
import "./popovertip.less";
import { Popover } from "../BP2Components";

const PopoverTip = (props) => {
   return (
      <Popover
         placement={props.position ? props.position : "right"}
         title={props.title}
         content={<div className="tip-content p3">{props.content}</div>}
         trigger="hover"
      >
         <span className="tip-icon">?</span>
      </Popover>
   );
};

export default PopoverTip;
